import { toast } from 'sonner';
import { createLogger } from '@metron/shared';

const logger = createLogger('clipboard');

/**
 * Copy a value and tell the user what actually happened.
 *
 * The Clipboard API rejects on a denied permission, a non-secure context, or
 * OS policy, so the success toast has to be conditional on the write. Reporting
 * success regardless is worse than useless when the value is a one-time
 * credential the user is about to paste somewhere else.
 */
export async function copyToClipboard(value: string, label: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    toast.success(`${label} copied to clipboard`);
    return true;
  } catch (err) {
    toast.error(`Failed to copy ${label.toLowerCase()} to clipboard`);
    logger.error({ err, label }, 'Clipboard write failed');
    return false;
  }
}
